// extracted by mini-css-extract-plugin
export var backdrop = "Dialog-module--backdrop--20c5f";
export var closeForm = "Dialog-module--closeForm--dfdd1";
export var dialog = "Dialog-module--dialog--88d48";
export var icon = "Dialog-module--icon--5017f";